export enum CachedTableNamesEnum {
	FEDERATED_IDENTITY = 'federated_identity',
	PROGRAM = 'program'
}
